import { render } from "./FormParameterEditor.vue?vue&type=template&id=654d58a5&scoped=true&ts=true"
import script from "./FormParameterEditor.vue?vue&type=script&lang=ts"
export * from "./FormParameterEditor.vue?vue&type=script&lang=ts"

import "./FormParameterEditor.vue?vue&type=style&index=0&id=654d58a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654d58a5"]])

export default __exports__